module.exports = __webpack_public_path__ + "static/postgres-small-5018e1df82b46319c9bf58fa16662108.png";